import { useNavigate } from "react-router-dom";
import { CalendarDays, MapPin, Users } from "lucide-react";
import { fmtRange, rallyStatus } from "../lib/dates";
import { API } from "../context/AuthContext";

const abs = (u) => (u && u.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${u}` : u);

export function StatusPill({ start, end, className = "" }) {
  const s = rallyStatus(start, end);
  const cls = s.code === "LIVE" ? "bg-[#FF1E27] text-white animate-pulse" : s.code === "FINISHED" ? "bg-white/10 text-slate-300" : "bg-[#FF9F0A]/15 text-[#FF9F0A]";
  return <span className={`px-2 py-0.5 rounded-full font-mono-rl text-[10px] tracking-widest ${cls} ${className}`} data-testid="rally-status">{s.code === "LIVE" && "● "}{s.label}</span>;
}

export default function RallyCard({ r, testid, index = 0, to, countdown }) {
  const nav = useNavigate();
  const dates = fmtRange(r.start_date, r.end_date);
  const days = countdown && r.start_date ? Math.ceil((new Date(r.start_date + "T00:00:00") - Date.now()) / 86400000) : null;
  return (
    <button onClick={() => nav(to || `/paddock/${r.id}`)} data-testid={testid || `rally-card-${r.id}`}
      className="rl-card text-left hover:border-[#FF1E27]/50 hover:-translate-y-1 transition group overflow-hidden flex flex-col"
      style={{ animationDelay: `${index * 80}ms` }}>
      <div className="relative h-36 bg-[#141826]">
        {r.cover_image && <img src={abs(r.cover_image)} alt={`Copertina ${r.name}`} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition" loading="lazy" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D14] to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2"><StatusPill start={r.start_date} end={r.end_date} />{r.demo && <span className="px-2 py-0.5 rounded-full font-mono-rl text-[10px] tracking-widest bg-black/60 border border-white/15 text-slate-300">DEMO</span>}{r.card_accepted && <span className="px-2 py-0.5 rounded-full font-mono-rl text-[10px] tracking-widest bg-[#FF9F0A] text-black" data-testid={`card-accepted-${r.id}`}>RALLY LOVE CARD ACCEPTED</span>}</div>
        {r.logo_url && <img src={abs(r.logo_url)} alt="" className="absolute bottom-3 right-3 h-10 object-contain drop-shadow" />}
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="font-mono-rl text-[10px] text-[#FF1E27] tracking-widest mb-1">OFFICIAL PADDOCK</div>
        <div className="font-display font-black text-xl mb-2 group-hover:text-[#FF9F0A] transition line-clamp-2">{r.name}</div>
        <div className="space-y-1 text-xs text-slate-400">
          <div className="flex items-center gap-1.5"><MapPin className="w-3 h-3" /> {r.location || "—"}{r.region ? ` · ${r.region}` : r.country ? ` · ${r.country}` : ""}</div>
          {dates && <div className="flex items-center gap-1.5"><CalendarDays className="w-3 h-3" /> {dates}</div>}
        </div>
        <div className="mt-4 flex items-center justify-between font-mono-rl text-xs">
          <span className="flex items-center gap-1 text-slate-500"><Users className="w-3 h-3" /> {r.fans} FAN</span>
          {days > 0 && <span className="text-[#FF9F0A]" data-testid={`countdown-${r.id}`}>TRA {days} {days === 1 ? "GIORNO" : "GIORNI"}</span>}
          <span className="text-[#30D158]">GIOCA →</span>
        </div>
      </div>
    </button>
  );
}
